import { createContext, ReactNode, useContext } from 'react';

import useAxios from 'axios-hooks';

class EnumValuesError extends Error {}

export enum EnumValueNames {
  CompetitorStatus = 'competitorstatustype',
  Competitors = 'competitortype',
  Contract = 'contracttype',
  EventStatus = 'eventstatustype',
  Event = 'eventtype',
  FixtureCompetitor = 'fixturecompetitortype',
  Gender = 'gendertype',
  AgeCategory = 'agecategory',
  Locality = 'localitytype',
  Round = 'roundtype',
  Venue = 'venuetype',
  Resource = 'resourcetype',
  TriggerType = 'triggertype',
  FixtureStatusType = 'fixturestatustype',
  LocalityCode = 'iso3countrycode',
}

export type EnumValue = {
  name: string;
  value: number;
};

export type EnumValueString = {
  name: string;
  value: string;
};
export type EnumsData = {
  [_ in EnumValueNames]: Array<EnumValue>;
};

type EnumValuesType = {
  enumValues: EnumsData;
  error: EnumValuesError;
};
export const EnumsValuesContext = createContext<EnumValuesType>({} as EnumValuesType);

export const EnumValuesProvider = ({ children }: { children: ReactNode }) => {
  const [{ data, error }] = useAxios<EnumsData>('enums/all');

  return (
    <EnumsValuesContext.Provider value={{ enumValues: data, error }}>
      {children}
    </EnumsValuesContext.Provider>
  );
};

export const useEnumValues = () => useContext(EnumsValuesContext);

export const useEnum = (key: EnumValueNames) =>
  useContext(EnumsValuesContext)?.enumValues?.[key] || [];
